/**
 *  @swagger
 *  definitions:
 *    RegattaEntryRatingParams:
 *      type: object
 *      properties:
 *        RegattaEntryId:
 *          description: ID of the associated RegattaEntry
 *          type: string
 *        RatingId:
 *          description: ID of the associated Rating
 *          type: string
 *
 *  @swagger
 *  definitions:
 *    RegattaEntryRatingCreateParams:
 *      allOf:
 *        - $ref: '#/definitions/RegattaEntryRatingParams'
 *        - type: object
 *          required:
 *            - RegattaEntryId
 *            - RatingId
 *
 *  @swagger
 *  definitions:
 *    RegattaEntryRatingQueryParams:
 *      allOf:
 *        - type: object
 *          properties:
 *            id:
 *              description: ID of the RegattaEntryRating
 *              type: string
 *        - $ref: '#/definitions/RegattaEntryRatingParams'
 *
 *  @swagger
 *  definitions:
 *    RegattaEntryRatingUpdateParams:
 *      allOf:
 *        - $ref: '#/definitions/RegattaEntryRatingQueryParams'
 *        - type: object
 *          required:
 *            - id
 *
 *  @swagger
 *  definitions:
 *    RegattaEntryRating:
 *      allOf:
 *        - $ref: '#/definitions/RegattaEntryRatingCreateParams'
 *        - $ref: '#/definitions/RegattaEntryRatingUpdateParams'
 *        - $ref: '#/definitions/Timestamps'
 *
 *  @swagger
 *  components:
 *    schemas:
 *      RegattaEntryRating:
 *        allOf:
 *          - $ref: '#/definitions/RegattaEntryRating'
 *          - type: object
 *            properties:
 *              RegattaEntry:
 *                description: RegattaEntry of the RegattaEntryRating
 *                $ref: '#/components/schemas/RegattaEntry'
 *              Rating:
 *                description: Rating of the RegattaEntryRating
 *                $ref: '#/components/schemas/Rating'
 */

// Types
import type {
  $Model,
  $ModelClass,
  $ModelClasses,
} from '.';
import type {
  $Field,
} from '../types';

export type $RelationIds = {
  RatingId: string;
  RegattaEntryId: string;
};
export type $CreateParams = $RelationIds;

export type $UpdateParams = {
  id: string;
} & Partial<$CreateParams>;

export type $UpsertParams = $CreateParams & {
  id?: string;
};

export type $QueryParams = {
  id?: null | string;
} & Partial<$CreateParams>;

export type $Associations = {
  Rating?: $Model<'Rating'>;
  RegattaEntry?: $Model<'RegattaEntry'>;
};

export type $ModelParams = $Associations & $CreateParams & {
  id: string;
};

type $Fields = {
  id: string;
};

const fields = (
  Sequelize,
): Record<keyof $Fields, $Field> => ({
  id: {
    allowNull: false,
    defaultValue: Sequelize.UUIDV4,
    primaryKey: true,
    type: Sequelize.UUID,
    unique: true,
  },
});

export default ((
  Sequelize,
  stack,
): $ModelClass<'RegattaEntryRating'> => {
  const RegattaEntryRating = stack.define(
    'RegattaEntryRating',
    fields(Sequelize),
    {
      tableName: 'RegattaEntryRatings',
    },
  );

  RegattaEntryRating.associate = (models: $ModelClasses) => {
    models.RegattaEntryRating.belongsTo(
      models.RegattaEntry,
      {
        as: 'RegattaEntry',
        foreignKey: 'RegattaEntryId',
      },
    );
    models.RegattaEntryRating.belongsTo(
      models.Rating,
      {
        as: 'Rating',
        foreignKey: 'RatingId',
      },
    );
  };

  return RegattaEntryRating;
});
